import { IDesignatedDoctorInformationSource } from "./IDesignatedDoctorInformationSource";

export interface IDesignatedDoctorInformationSourceSpecifiable {
  designatedDoctorInformationSource: IDesignatedDoctorInformationSource;
}

export function instanceOfIDesignatedDoctorInformationSourceSpecifiable(instance: any): instance is IDesignatedDoctorInformationSourceSpecifiable {
  return instance
    && (instance.designatedDoctorInformationSource !== undefined);
}
